import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ExerciseQuestionsFragmentDoc } from '../../../../../../../../content/modules/exercise/fragments/generated/ExerciseQuestions';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ExercisesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ContentFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type ExercisesQuery = { contents: { edges?: Array<{ node: { id: string, name: string, exerciseQuestions: Array<{ id: string, text: string, responseType: Types.ResourceResponseTypeEnum, medias?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, imageHotspots?: Array<{ mediaId: string, hotspots: Array<{ id: string, x: number, y: number }> }> | null, customRatingComponent?: { ratingLabels: Array<{ labelName: string, rating?: number | null }> } | null }> } | {} }> | null } };


export const ExercisesDocument = /*#__PURE__*/ gql`
    query exercises($filters: ContentFilters, $sort: [SortType!]) {
  contents(filters: $filters, sort: $sort) {
    edges {
      node {
        ... on ExerciseType {
          id
          name
          exerciseQuestions {
            ...ExerciseQuestions
          }
        }
      }
    }
  }
}
    ${ExerciseQuestionsFragmentDoc}
${EntityMediaFragmentDoc}`;

export function useExercisesQuery(options?: Omit<Urql.UseQueryArgs<ExercisesQueryVariables>, 'query'>) {
  return Urql.useQuery<ExercisesQuery, ExercisesQueryVariables>({ query: ExercisesDocument, ...options });
};